import { setAppSpinning } from 'app/appSlice'
import AppResource from 'general/constants/AppResource'
import { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { useSearchParams } from 'react-router-dom'
import ModalViewInvoice from './components/ModalViewInvoice'
import NotFoundError from './components/NotFoundError'
import './style.scss'
import miscApi from 'api/miscApi'
import accountingdocumentApi from 'api/accountingdocumentApi'
import ModalAccountingdocument from './components/ModalAccountingdocument'
import BaseConfig from 'general/constants/DomainConfig'
import { useHostname } from 'general/context/HostnameContext'

function Search({ accounting_document }) {
  const dispatch = useDispatch()
  const [searchParam] = useSearchParams()
  const initialLookupCode = searchParam.get('lookupCode')
  const [invoiceLookupCode, setInvoiceLookupCode] = useState('')
  const [invoice, setInvoice] = useState()
  const [accountingDocument, setAccountingDocument] = useState()
  const [showModalViewInvoice, setShowModalViewInvoice] = useState(false)
  const [showModalViewAD, setShowModalViewAD] = useState(false)

  const [notFoundInvoiceLookupCode, setNotFoundInvoiceLookupCode] = useState()

  const [invoiceUrl, setInvoiceUrl] = useState()
  const hostname = useHostname()
  console.log({ hostname })

  const handleSearchInvoice = async (lookupCode) => {
    dispatch(setAppSpinning(true))
    try {
      let res = await miscApi.findByLookupCode(lookupCode)
      let resPdf = await miscApi.exportLookupCode(lookupCode)
      dispatch(setAppSpinning(false))

      // thay link
      const fileURL = resPdf?.fileURL
      const url = fileURL
        ? /^https?:\/\//.test(fileURL)
          ? fileURL
          : `${process.env.REACT_APP_BASE_URL}${fileURL}`
        : ''
      setInvoice(res.data)
      setInvoiceUrl(url)
      setNotFoundInvoiceLookupCode(null)

      setShowModalViewInvoice(true)
    } catch (e) {
      console.log(e)
      dispatch(setAppSpinning(false))
      setNotFoundInvoiceLookupCode(lookupCode)
    }
  }

  const handleSearchAccounting_document = async (lookupCode) => {
    dispatch(setAppSpinning(true))
    try {
      let resXML = await accountingdocumentApi.exportByLookupCode(
        lookupCode,
        'XML',
      )
      let resPdf = await accountingdocumentApi.exportByLookupCode(
        lookupCode,
        'PDF',
      )
      dispatch(setAppSpinning(false))
      // Chuyển dữ liệu Buffer thành Uint8Array
      if (resXML?.message == 'success') {
        let pdfData = new Uint8Array(resPdf?.data?.data)

        // Tạo Blob từ dữ liệu PDF
        let blob = new Blob([pdfData], { type: 'application/pdf' })

        // Tạo URL để hiển thị file PDF
        let fileURL = URL.createObjectURL(blob)

        // let newFile = new File([blob], resPdf?.fileName, {
        //   type: 'application/pdf',
        // })
        setAccountingDocument({ resXML, resPdf })
        setInvoiceUrl(fileURL)
        setNotFoundInvoiceLookupCode(null)
        setShowModalViewAD(true)
      } else {
        setShowModalViewAD(false)
        setAccountingDocument(null)
        dispatch(setAppSpinning(false))
        setNotFoundInvoiceLookupCode(lookupCode)
      }
    } catch (e) {
      console.log(e)
      dispatch(setAppSpinning(false))
      setNotFoundInvoiceLookupCode(lookupCode)
    }
  }

  useEffect(() => {
    if (initialLookupCode) {
      setInvoiceLookupCode(initialLookupCode)
      if (window.location.pathname.includes('tra-cuu-chung-tu')) {
        handleSearchAccounting_document(initialLookupCode)
      } else {
        handleSearchInvoice(initialLookupCode)
      }
    }
  }, [initialLookupCode])

  return (
    <>
      <div className="Search">
        <div className="top-bar">
          <a
            href="#"
            onClick={(e) => {
              e.stopPropagation()
            }}
          >
            <img src={BaseConfig[hostname]?.logo} width={200} />
          </a>
        </div>

        <div>
          <div
            className="layout-tra-cuu d-flex justify-content-center"
            style={{ marginBottom: '4em' }}
          >
            <div className="d-flex align-items-center justify-content-center col-12">
              <div className="row" style={{ width: '41%' }}>
                <div className="col-12 mb-5">
                  <div className="text-white text-center">
                    <h4 className="font-medium text-2xl m-0">
                      TRA CỨU{' '}
                      {accounting_document
                        ? 'CHỨNG TỪ THU NHẬP CÁ NHÂN'
                        : 'HÓA ĐƠN ĐIỆN TỬ'}
                      <br />
                      {BaseConfig[hostname]?.name}
                    </h4>
                  </div>
                </div>
                <div className="col-12 mb-7">
                  <input
                    placeholder="Nhập mã tra cứu"
                    className="w-100 search-input"
                    required
                    value={invoiceLookupCode}
                    onChange={(e) => {
                      setInvoiceLookupCode(e.target.value)
                    }}
                    onKeyDown={(e) => {
                      if (e.key == 'Enter') {
                        accounting_document
                          ? handleSearchAccounting_document(invoiceLookupCode)
                          : handleSearchInvoice(invoiceLookupCode)
                      }
                    }}
                  />
                </div>
                <div className="col-12">
                  <div className="text-center">
                    <button
                      className="btn btn-success d-inline-flex align-items-center"
                      onClick={() => {
                        accounting_document
                          ? handleSearchAccounting_document(invoiceLookupCode)
                          : handleSearchInvoice(invoiceLookupCode)
                      }}
                    >
                      <i className="fa-regular fa-magnifying-glass"></i>
                      <span style={{ fontSize: '16px' }}>Tra cứu</span>
                    </button>
                  </div>
                </div>

                {notFoundInvoiceLookupCode && (
                  <div className="col-12">
                    <NotFoundError
                      text={`Không tìm thấy ${accounting_document ? `chứng từ` : `hóa đơn`} có mã tra cứu: ${notFoundInvoiceLookupCode}`}
                    />
                  </div>
                )}
              </div>
            </div>
          </div>

          <div className="layout-loi-ich mb-5">
            <h2 className="text-center mt-7 mb-0">
              Lợi ích{' '}
              {accounting_document ? 'chứng từ thu nhập cá nhân' : 'hóa đơn'}{' '}
              điện tử
            </h2>

            <div className="p-3">
              <div className="row">
                <div className="col-12 col-md-3 col-lg-3">
                  <div className="item">
                    <div className="item-img">
                      <img src={AppResource.images.img_nghiep_vu} alt="" />
                    </div>
                    <div className="item-title text-center m-3">
                      ĐÁP ỨNG NGHIỆP VỤ
                    </div>
                    <div className="item-text text-center">
                      Đảm bảo đáp ứng toàn bộ nghiệp vụ theo quy định của Tổng
                      cục thuế
                    </div>
                  </div>
                </div>
                <div className="col-12 col-md-3 col-lg-3">
                  <div className="item">
                    <div className="item-img">
                      <img src={AppResource.images.img_hieu_qua} alt="" />
                    </div>
                    <div className="item-title text-center m-3">
                      TIẾT KIỆM - HIỆU QUẢ
                    </div>
                    <div className="item-text text-center">
                      Tiết kiệm 90% chi phí in ấn, vận chuyển, lưu trữ và bảo
                      quản hóa đơn
                    </div>
                  </div>
                </div>
                <div className="col-12 col-md-3 col-lg-3">
                  <div className="item">
                    <div className="item-img">
                      <img src={AppResource.images.img_an_toan} alt="" />
                    </div>
                    <div className="item-title text-center m-3">
                      AN TOÀN - BẢO MẬT
                    </div>
                    <div className="item-text text-center">
                      Sử dụng công nghệ bảo mật nhiều lớp, an toàn tuyệt đối
                      trong việc quản lý và lưu trữ.
                    </div>
                  </div>
                </div>
                <div className="col-12 col-md-3 col-lg-3">
                  <div className="item">
                    <div className="item-img">
                      <img src={AppResource.images.img_tu_van} alt="" />
                    </div>
                    <div className="item-title text-center m-3">
                      TƯ VẤN - HỖ TRỢ
                    </div>
                    <div className="item-text text-center">
                      Triển khai nhanh, hỗ trợ thông báo phát hành hóa đơn, tư
                      vấn nghiệp vụ trong việc sử dụng hóa đơn.
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="layout-footer text-center text-white p-8">
            {/* <b>CÔNG TY CỔ PHẦN XĂNG DẦU TỰ LỰC I</b> */}
            {/* <p>
              <i className="fa-solid fa-location-dot mr-2"></i>Địa chỉ: Đường La Thành, Phường Phú Thịnh, Thị Xã Sơn Tây, TP.Hà Nội
            </p> */}
            <b>{BaseConfig[hostname]?.companyInfo?.name}</b>
            <p>
              <i className="fa-solid fa-location-dot mr-2"></i>
              {BaseConfig[hostname]?.companyInfo?.address}
            </p>
            {BaseConfig[hostname]?.companyInfo?.headquarters && (
              <p>
                <i className="fa-solid fa-location-dot mr-2"></i>
                {BaseConfig[hostname]?.companyInfo?.headquarters}
              </p>
            )}
            <p>
              <i className="fa-solid fa-phone mr-2"></i>
              <b>Hotline:</b> {BaseConfig[hostname]?.companyInfo?.hotline}
            </p>
            {BaseConfig[hostname]?.companyInfo?.email && (
              <p>
                <i className="fa-regular fa-envelope mr-2"></i>
                <b>Email:</b> {BaseConfig[hostname]?.companyInfo?.email}
              </p>
            )}
          </div>
        </div>
      </div>

      {invoice && (
        <ModalViewInvoice
          invoiceUrl={invoiceUrl}
          lookupCode={invoiceLookupCode}
          invoice={invoice}
          showModalViewInvoice={showModalViewInvoice}
          setShowModalViewInvoice={setShowModalViewInvoice}
        />
      )}
      <ModalAccountingdocument
        invoiceUrl={invoiceUrl}
        lookupCode={invoiceLookupCode}
        invoice={{}}
        accountingDocument={accountingDocument}
        showModalViewAD={showModalViewAD}
        setShowModalViewAD={setShowModalViewAD}
      />
    </>
  )
}

export default Search
